module.exports = __webpack_public_path__ + "img/6.49e6397c.jpg";